import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.tsx';
import { store } from './store';
import './index.css';
import './utils/silentConsole'; // Desabilita logs verbosos de debug
import './integrations/sentry/client';
import { syncHostSession } from './embed/session-sync';

// Antes do React montar: se a sessão do portal que embute trocou, o token e o
// cache desta aba são do usuário anterior. Depois do primeiro render seria
// tarde — o useKeycloakAuth confere a autenticação na montagem.
syncHostSession();

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App />
  </Provider>
);
